import { __assign } from "tslib";
import { createTheme } from '@mui/material/styles';
import { theme as themeBase } from '../index';
import { Theme, modeForMUI } from '../../../types';
var colors = {
    'main-color-cl-01': '#00205B',
    'main-color-cl-01-hover': '#002B7A',
    'main-color-cl-02': '#2D78C6',
    'main-color-cl-03': '#37AFEB',
    'main-color-cl-04': '#81D1F7',
    'main-color-cl-05': '#BBE9FF',
    'main-color-cl-06': '#E3F7FF',
    'main-color-cl-07': '#F6F8FC',
    'main-color-cl-08': '#FFFFFF',
    'main-color-cl-09': '#F3F3F3',
    'main-color-cl-10': '#212134',
    'main-color-cl-11': '#32324D',
    'main-color-cl-12': '#4A4A6A',
    'main-color-cl-13': '#666687',
    'main-color-cl-14': '#8E8EA9',
    'main-color-cl-15': '#A5A5BA',
    'main-color-cl-16': '#C0C0CF',
    'main-color-cl-17': '#DCDCE4',
    'main-color-cl-18': '#EAEAEF',
    'main-color-cl-19': '#F6F6F9',
    'main-color-cl-20': '#00BC4B',
    'main-color-cl-21': '#D02B20',
    'main-color-cl-22': '#F29D41',
    'main-color-cl-30': '#0000FF',
    'main-color-cl-31': '#1CE783',
    'main-color-cl-32': '#EFEFED',
    'main-color-cl-40': '#E5E5E7',
    'main-color-cl-90': 'rgba(#FF00FF, 0.3)',
    'main-color-cl-91': '#FF00FF',
    'main-color-cl-92': '#FCFCFD',
    'main-color-cl-93': '#FF8000',
    'main-color-cl-94': '#E71D1C',
    'main-color-cl-95': '#101828',
    'main-color-cl-96': '#000033',
    'main-color-cl-97': '#000066',
    'main-color-cl-98': '#475467',
    'main-color-cl-99': '#667085',
    'main-color-cl-100': '#98a2b3',
};
var darkThemeBase = createTheme(themeBase, {
    palette: {
        mode: modeForMUI[Theme.DARK_CLASSIC],
        primary: {
            main: colors['main-color-cl-30'],
            dark: colors['main-color-cl-30'],
            contrastText: colors['main-color-cl-19'],
        },
        secondary: {
            light: colors['main-color-cl-16'],
            main: colors['main-color-cl-14'],
            dark: colors['main-color-cl-14'],
            contrastText: colors['main-color-cl-19'],
        },
        error: {
            main: colors['main-color-cl-21'],
            contrastText: colors['main-color-cl-08'],
        },
        warning: {
            main: colors['main-color-cl-22'],
            contrastText: colors['main-color-cl-08'],
        },
        info: {
            main: colors['main-color-cl-30'],
            contrastText: colors['main-color-cl-08'],
        },
        success: {
            main: colors['main-color-cl-31'],
            contrastText: colors['main-color-cl-01'],
        },
        text: {
            primary: colors['main-color-cl-01'],
            secondary: colors['main-color-cl-19'],
        },
        action: {
            disabled: colors['main-color-cl-19'],
            disabledBackground: colors['main-color-cl-16'],
        },
        background: {
            default: colors['main-color-cl-96'],
            primary: colors['main-color-cl-30'],
            paper: colors['main-color-cl-08'],
            secondary: colors['main-color-cl-07'],
        },
        // paper: {
        // paper: themeBase.palette.augmentColor({
        //   color: {
        //     main: `linear-gradient(168.64deg, ${colors['main-color-cl-30']} 8.37%, #0000C9 95.34%)`,
        //   },
        //   name: 'paper',
        // }),
        // primary: `linear-gradient(168.64deg, ${colors['main-color-cl-30']} 8.37%, #0000C9 95.34%)`,
        // },
        link: {
            primary: colors['main-color-cl-31'],
        },
        placeholder: {
            primary: colors['main-color-cl-15'],
        },
        grey: {
            100: colors['main-color-cl-19'],
            200: colors['main-color-cl-18'],
            300: colors['main-color-cl-17'],
            400: colors['main-color-cl-16'],
            500: colors['main-color-cl-15'],
            600: colors['main-color-cl-14'],
            700: colors['main-color-cl-13'],
            800: colors['main-color-cl-12'],
            900: colors['main-color-cl-11'],
        },
        focus: themeBase.palette.augmentColor({
            color: {
                main: colors['main-color-cl-31'],
            },
            name: 'focus',
        }),
    },
    shape: {
        borderRadius: 8,
    },
});
/** @todo remove 'important' after remove global styles */
export var darkClassicTheme = createTheme(darkThemeBase, {
    components: {
        MuiPaper: {
            styleOverrides: {
                root: function (_a) {
                    var ownerState = _a.ownerState;
                    return (__assign({}, (ownerState.color === 'primary' && {
                        background: "linear-gradient(168.64deg, ".concat(colors['main-color-cl-30'], " 8.37%, #0000C9 95.34%)"),
                    })));
                },
            },
        },
        MuiButton: {
            variants: [
                {
                    props: { variant: 'outlined', color: 'primary' },
                    style: {
                        backgroundColor: darkThemeBase.palette.primary.contrastText,
                    },
                },
                {
                    props: { variant: 'outlined', color: 'secondary' },
                    style: {
                        backgroundColor: darkThemeBase.palette.secondary.contrastText,
                    },
                },
            ],
        },
        MuiChip: {
            variants: [
                {
                    props: { variant: 'outlined' },
                    style: {
                        borderWidth: '2px',
                        color: darkThemeBase.palette.text.primary,
                    },
                },
                {
                    props: { variant: 'filled', color: 'default' },
                    style: {
                        backgroundColor: darkThemeBase.palette.grey[500],
                        color: darkThemeBase.palette.primary.contrastText, // @todo change to some gray contrastText
                    },
                },
                {
                    props: { variant: 'outlined', color: 'default' },
                    style: {
                        borderColor: darkThemeBase.palette.grey[500],
                    },
                },
            ],
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    opacity: 1,
                },
            },
            variants: [
                {
                    props: { variant: 'primary' },
                    style: {
                        borderWidth: '2.5px',
                        backgroundColor: darkThemeBase.palette.focus.main,
                        borderColor: 'transparent',
                    },
                },
            ],
        },
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    color: darkThemeBase.palette.text.primary,
                    border: 'none',
                    background: darkThemeBase.palette.background.paper,
                    width: '100%',
                    '.MuiDataGrid-cell, .MuiDataGrid-cell, .MuiDataGrid-columnHeaderTitleContainer, .MuiDataGrid-columnHeader': {
                        '&:focus, &:focus-within': {
                            outline: 'none',
                        },
                    },
                    '& .MuiDataGrid-row:hover': {
                        backgroundColor: darkThemeBase.palette.grey[100],
                    },
                },
                cell: {
                    paddingTop: '12px',
                    paddingBottom: '6px',
                    alignItems: 'start',
                    borderBottom: "1px solid ".concat(darkThemeBase.palette.grey[200]),
                },
                columnHeaderTitle: {
                    fontWeight: 'bold',
                },
                columnHeaders: {
                    borderBottom: "1px solid ".concat(darkThemeBase.palette.grey[200]),
                },
                columnSeparator: {
                    color: darkThemeBase.palette.grey[200],
                },
            },
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    color: "".concat(darkThemeBase.palette.text.primary, " !important"),
                },
            },
        },
    },
});
